import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	depTableNames: [],
	depTableSettings: {},
	edit: {
		Text: null as string | null,
		TitulId: null as number | null,
		ZajmenemPrp: null as boolean | null,
	},
	localState: {},
	props: {
		mode: null,
	},
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
});
